// Ruby-format log keys ('2026-10-11 06:49:23.053985432 +0000') → ISO, since Safari's Date (moment's fallback) rejects them (#30192)
export const logKeyToIso = key => {
  const m =
    /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})(?:\.(\d+))?(?: (?:([+-]\d{2}):?(\d{2})|(UTC)))?$/.exec(
      key
    )
  if (!m) return key
  const ms = m[3] ? `.${m[3].slice(0, 3).padEnd(3, '0')}` : ''
  const offset = m[4] ? `${m[4]}:${m[5]}` : m[6] ? 'Z' : ''
  return `${m[1]}T${m[2]}${ms}${offset}`
}
